module.exports = __webpack_public_path__ + "img/thumbnail-1@2x.9c804512.jpg";